import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      width: '100%',
      justifyContent: 'space-between',
    },
    paddingTop: {
      paddingTop: theme.spacing.xxxl,
    },
    input: {
      marginBottom: theme.spacing.sm,
    },
    buttonContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingBottom: theme.spacing.md,
    },
    errorText: {
      marginBottom: theme.spacing.sm,
    },
  })
